import { request } from '../request';
import { getCommonParams } from '../request/params';
import { signCalc } from '../request/sign';
import { IPostEventReportParams } from '../types';

const postEventReportByFetch = async (url: string, data: IPostEventReportParams) => {
  // api request params
  const queryParams: Record<string, any> = getCommonParams();
  url += '?';
  for (const key in queryParams) {
    url += `${key}=${queryParams[key]}&`;
  }

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  const [sign, timestamp] = signCalc(queryParams, data);
  if (sign !== undefined) {
    headers['x-sign'] = String(sign);
  }
  if (timestamp !== undefined) {
    headers['x-timestamp'] = String(timestamp);
  }

  await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
    keepalive: true,
  });
};

export const postEventReport = async (data: IPostEventReportParams) => {
  const url = `/weaver/api/v1/event/report`;

  // @ts-ignore
  if (typeof window !== 'undefined' && window.fetch) {
    await postEventReportByFetch(url, data);
  } else {
    await request.post(url, data);
  }
};
